/*
  nc-selectable-toggles – gør fane-overskrifterne på produktsiden ("Tekniske specifikationer",
  "Specifikationer", "Download materialer" …) markérbare, så teksten kan kopieres.
  Browsere tillader ikke tekstmarkering i <button>, så knappen skiftes ud med et
  <div role="button" tabindex="0"> med samme klasser/attributter. Athens' CollapsibleExpandable
  (scripts.js) er uændret: vi peger blot dens toggleElement på det nye element.
  Kort klik åbner/lukker som før; hvis brugeren har markeret tekst i overskriften, sker intet.
  Indlæses kun på produktsider (layout/theme.liquid).
*/
(() => {
  function swap(ce) {
    const btn = ce.toggleElement;
    if (!btn || btn.tagName !== 'BUTTON' || !btn.textContent.trim()) return;

    const el = document.createElement('div');
    for (const attr of btn.attributes) {
      if (attr.name !== 'type') el.setAttribute(attr.name, attr.value);
    }
    el.setAttribute('role', 'button');
    el.tabIndex = 0;
    el.classList.add('nc-selectable-toggle');
    while (btn.firstChild) el.appendChild(btn.firstChild);
    btn.replaceWith(el);
    ce.toggleElement = el;

    el.addEventListener('click', (event) => {
      const sel = window.getSelection();
      if (sel && !sel.isCollapsed && el.contains(sel.anchorNode)) {
        event.stopImmediatePropagation();
        return;
      }
      ce.onToggle(event);
    });
    el.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        ce.onToggle(event);
      }
    });
  }

  function run() {
    document.querySelectorAll('collapsible-expandable').forEach(swap);
  }

  customElements.whenDefined('collapsible-expandable').then(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  });
})();
